import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import TableLayout from './TableLayout';
import { Query } from 'react-apollo';
import qs from 'qs';
import { PORTAL_ORDER_ITEMS_QUERY } from './graphql';

class Items extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            skip: 0,
            first: 20,
            initialPage: 0,
            refetch: false
        };

        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleCompletedFetching = this.handleCompletedFetching.bind(this);
    }

    componentDidMount() {
        const params =  qs.parse(window.location.search, {
            ignoreQueryPrefix: true
        });
        const { p: page } = params;
        const initialPage = (page) ? page-1 : 0;
        const skip = (initialPage > 0) ? page * 20 : 0;
        this.setState({
            skip,
            initialPage
        });
    }

    handleCompletedFetching() {
        this.setState({
            refetch: false
        });
    }

    toggleRefetch() {
        const { refetch } = this.props;
        this.setState({
            refetch: !refetch
        });
    }

    handlePageClick(data) {
        const { selected } = data;
        const skip = Math.ceil(selected * 20);
        const initialPage = selected;
        this.setState({
            skip,
            initialPage
        });
        this.props.history.push({
            pathname: '/itens',
            search: "?" + new URLSearchParams({
                p: (selected+1)
            }).toString()
        });
      }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.refetch && !prevState.refetch) {
            this.setState({
                refetch: false
            });
        }

        if (JSON.stringify(this.props.filters) !== JSON.stringify(prevProps.filters)) {
            this.setState({
                refetch: true
            });
        }
    }

    render() {
        const { operatorId, filters } = this.props;
        const { first, skip, initialPage } = this.state;
        const variables = {
            operatorId,
            skip,
            first,
            ...filters
        };

        return (
            <Query
                query={PORTAL_ORDER_ITEMS_QUERY}
                variables={variables}
            >
                {({ loading, data, refetch, error }) => {
                    if (this.state.refetch){
                        refetch();
                    }
                    const { portalOrderItems } = data || {}
                    const { itemsCount,
                            billsAmount,
                            fareAmount,
                            customAmount,
                            remnantAmount,
                            orderItems } = portalOrderItems || {}
                    return(
                        <Fragment>
                            <Header
                                billsAmount={billsAmount}
                                fareAmount={fareAmount}
                                customAmount={customAmount}
                                remnant_amount={remnantAmount}
                            />
                            <div
                                className="containter-fluid mt--6"
                                style={{paddingLeft:"39px",paddingRight:"39px"}}
                            >
                                <div className="row">
                                    <div className='col'>
                                        <TableLayout
                                            error={error}
                                            data={orderItems}
                                            loading={loading}
                                            initialPage={initialPage}
                                            onPageClick={this.handlePageClick}
                                            count={itemsCount}
                                            first={first}
                                            skip={first*initialPage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    );
                }}
            </Query>
        );
    }
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId,
    filters: state.order_items.filters
});

export default connect(mapStateToProps)(Items);



// WEBPACK FOOTER //
// ./src/components/Pages/Items/index.js